

import React from 'react'
import { navigateTo } from "gatsby-link"
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'
import CookieBanner from 'react-cookie-banner'
import CssBaseline from '@material-ui/core/CssBaseline'
import WebFont from 'webfontloader'
import { detect } from 'detect-browser'
import { withStyles, MuiThemeProvider } from '@material-ui/core/styles'

import styles from './styles'
import { defaultTheme } from '../themes/default'

import Header from '../components/header'
import Navigation from '../components/nav'
import Unsupported from '../components/unsupported'

const browser = detect()

class Layout extends React.Component {
  state = {
    open: false,
    preview: process.env.ENABLE_GATSBY_REFRESH_ENDPOINT,
    unsupported: false
  }

  componentDidMount = () => {
    WebFont.load({
      typekit: {
        id: 'kij6mms',
      },
    })

    // if (
    //   browser &&
    //   !['chrome', 'firefox', 'safari', 'edge', 'ios', 'android'].includes(browser.name)
    // ) {
    //   this.setState({ unsupported: true})
    // }

  }

  toggle = () => {
    this.setState({
      open: !this.state.open,
    })
  }

  render() {
    const { children, classes, data } = this.props
    const { open, preview, unsupported } = this.state

    if (unsupported) {
      return (
        <div>
          <CssBaseline />
          <Unsupported />
          </div>
      )
    }

      if (this.props.location.pathname.includes('/videos/')) {
        return (
          <div>
            <CssBaseline />
            {children()}
          </div>
        )
      }

    return (
      <MuiThemeProvider theme={defaultTheme}>
        <div>
          {
            data &&
            <Helmet
              title={data.meta.siteMetadata.title}
              meta={[
                {
                  name: 'description',
                  content: data.meta.siteMetadata.description,
                },
                {
                  name: 'keywords',
                  content: data.meta.siteMetadata.keywords,
                },
              ]}
            >
              <html className={classes.root} lang="en" dir="ltr" />
            </Helmet>
          }
          <Header open={open} toggle={this.toggle} preview={preview} />
          <Navigation open={open} toggle={this.toggle} />
          <CssBaseline />
          {children()}
        </div>
      </MuiThemeProvider>
    )
  }
}

export default withStyles(styles)(Layout)

export const query = graphql`
  query layoutQuery {
    meta: site {
      siteMetadata {
        title
        description
        keywords
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js